<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <div>
        <h3
          v-if="payment.payment_mode === 'LEV'"
          class="capitalize-first text-base font-semibold"
        >
          {{ $t('global.who_issuer') }}
        </h3>
      </div>
      <div v-if="payment.payment_mode !== 'LEV' && placeHolderIssuer">
        <RadioCardComponent
          v-model="localPayment.tier_payant"
          :options="[
            {
              value: 0,
              label: placeHolderIssuer
            },
            {
              value: 1,
              label: $t('global.tiers_payant')
            }
          ]"
        />
      </div>
      <div
        v-else-if="payment.payment_mode === 'LEV'"
        class="text-medium w-1/2 rounded border-gray-300 bg-gray-100 px-2 py-5 text-gray-700"
      >
        {{ placeHolderDirectDebit }}
      </div>
    </div>
    <template
      v-if="localPayment.tier_payant === 1 && payment.payment_mode !== 'LEV'"
    >
      <div class="flex flex-col gap-2">
        <div>
          <h3 class="capitalize-first text-base font-semibold">
            {{ $t('global.third_party_payment_type') }}
          </h3>
        </div>
        <div>
          <RadioCardComponent
            v-model="localPayment.payer_type"
            :options="[
              {
                value: 'App\\Models\\Person',
                label: $t('global.dossier_contact')
              },
              {
                value: 'App\\Models\\Contact',
                label: $t('navigation.address_book_title_main')
              },
              {
                value: 'other',
                label: $t('attributes.OTHER')
              }
            ]"
          />
        </div>
        <div class="grid-form">
          <div
            v-if="localPayment.payer_type === 'App\\Models\\Person'"
            class="col-start-1"
          >
            <SelectComponent
              v-model="localPayment.payer_id"
              :label="$t('attributes.issuer_name')"
              name="contact"
              :values="dossierContacts"
              track-by="id"
              display-key="full_name"
              required
            />
          </div>
          <div
            v-if="localPayment.payer_type === 'App\\Models\\Contact'"
            class="col-start-1"
          >
            <SelectComponent
              v-model="localPayment.payer_id"
              :label="$t('attributes.issuer_name')"
              name="contact"
              :values="contacts"
              :none-selected-label="$t('global.first_letters_write')"
              track-by="id"
              display-key="full_name"
              searchable
              required
            />
          </div>
          <div v-if="localPayment.payer_type === 'other'" class="col-start-1">
            <BaseShowEditInput
              v-model="localPayment.issuer_name"
              :label="$t('attributes.issuer_name')"
              :edition-mode="true"
              name="issuer_name"
              :errors="errors.zip"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import BaseShowEditInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditInput.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import { mapGetters } from 'vuex'
import RadioCardComponent from '@c/BaseFormComponent/RadioCardComponent.vue'

export default {
  name: 'SelectIssuer',
  components: {
    RadioCardComponent,
    SelectComponent,
    BaseShowEditInput
  },
  props: {
    payment: {
      type: Number,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
    dossierContacts: {
      type: Array,
      required: true
    },
    placeHolderIssuer: {
      type: String,
      required: true
    },
    placeHolderDirectDebit: {
      type: String,
      required: true
    }
  },
  emits: ['update:payment'],
  computed: {
    ...mapGetters({
      contacts: 'metadata/getContactsMetadata'
    }),
    localPayment: {
      get() {
        return this.payment
      },
      set(value) {
        this.$emit('update:payment', value)
      }
    }
  },
  watch: {
    'localPayment.payer_type'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.localPayment.payer_id = null
      }
      if (newValue !== 'other') {
        this.localPayment.issuer_name = null
      }
    },
    'payment.tier_payant'(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue == 0) {
          this.localPayment.issuer_name = this.placeHolderIssuer
        } else {
          this.localPayment.issuer_name = ''
        }
      }
    }
  },
  mounted() {
    if (this.payment.tier_payant == 0) {
      this.localPayment.issuer_name = this.placeHolderIssuer
    } else {
      this.localPayment.issuer_name = ''
    }
  }
}
</script>
